var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#F2F2F2",
    x: 2.5,
    y: 0.5,
    width: 19,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#595959",
    fill: "#FFF",
    x: 0.5,
    y: 2.5,
    width: 19,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 5.119,
    y: 12,
    width: 9.817,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 5.119,
    y: 15,
    width: 9.817,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 5.119,
    y: 18,
    width: 9.817,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 8.119,
    y: 21,
    width: 4,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#595959",
    fill: "#F2F2F2",
    cx: 10.027,
    cy: 7.5,
    rx: 1.954,
    ry: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrLinks);
export default __webpack_public_path__ + "static/media/icon-qr-links.52cac27e3328013dd56658cb7fa0ed0c.svg";
export { ForwardRef as ReactComponent };